module.exports = __webpack_public_path__ + "img/welcome.7a6c4e08.jpg";